import '../lib/styles/index.scss'

// 组件
import AgGrid from './components/AgGrid/index.js'
import AgGridTextTooltip from './components/AgGridTextTooltip/index.js'
import AgGridWrap from './components/AgGridWrap/index.js'
import AutoWrap from './components/AutoWrap/index.js'
import BottomNavGroup from './components/BottomNav/index.js'
import BtnPosition from './components/BtnPosition/index.js'
import CardGroup from './components/Card/index.js'
import CommonAgGrid from './components/CommonAgGrid/index.js'
import Dialog from './components/Dialog/index.js'
import DialogTable from './components/DialogTable/index.js'
import DialogTree from './components/DialogTree/index.js'
import Drawer from './components/Drawer/index.js'
import Filter from './components/Filter/index.js'
import FilterBtn from './components/FilterBtn/index.js'
import FilterForm from './components/FilterForm/index.js'
import FloatingButton from './components/FloatingButton/index.js'
import Form from './components/Form/index.js'
import FormCard from './components/FormCard/index.js'
import FormCardList from './components/FormCardList/index.js'
import FormItem from './components/FormItem/index.js'
import InputDialog from './components/InputDialog/index.js'
import InputNumber from './components/InputNumber/index.js'
import Layout from './components/Layout/index.js'
import Logo from './components/Logo/index.js'
import Navbar from './components/Navbar/index.js'
import NavRightMenu from './components/NavRightMenu/index.js'
import Pagination from './components/Pagination/index.js'
import Pop from './components/Pop/index.js'
import RightMenu from './components/RightMenu/index.js'
import SearchForm from './components/SearchForm/index.js'
import SearchSelect from './components/SearchSelect/index.js'
import Sidebar from './components/Sidebar/index.js'
import Soduku from './components/Soduku/index.js'
import ThemeEditor from './components/ThemeEditor/index.js'
import TabGroup from './components/Tabs/index.js'
import TopNav from './components/TopNav/index.js'
import TreeTable from './components/TreeTable/index.js'
import SelectGroup from './components/Select/index.js'
import MultiSearch from './components/MultiSearch/index'
import FRPrint from './components/FineReport/Print/index'
import RFReport from './components/FineReport/Report/index'
import SearchTagGroup from './components/SearchTagGroup'
import Button from './components/Button'
import OnlyOffice from './components/OnlyOffice'
import WordTemplateRender from './components/WordTemplateRender'
import FileListGroup from './components/FileList'

export * from './components/ForGridComponents/cell-editor'

//  element 原始组件
import {
  Input,
  Alert,
  Avatar,
  // Button,
  Backtop,
  Badge,
  Breadcrumb,
  Checkbox,
  Divider,
  // InputNumber,
  Link,
  Loading,
  Notification,
  PageHeader,
  Popover,
  Progress,
  Radio,
  Rate,
  Row,
  Slider,
  Steps,
  Switch,
  Table,
  TableColumn,
  Tag,
  Tooltip,
  Carousel,
  Cascader,
  Collapse,
  ColorPicker,
  TimePicker,
  DatePicker,
  // DateTimePicker,
  TimeSelect,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Message,
  MessageBox,
  Popconfirm,
  Timeline,
  Transfer,
  Tree,
  Upload,
  RadioGroup,
  RadioButton,
  CheckboxButton,
  CheckboxGroup,
  ButtonGroup
} from 'element-ui'

// elementui组件
const elementComponents = [
  Input,
  Alert,
  Avatar,
  // Button,
  Backtop,
  Badge,
  Breadcrumb,
  Checkbox,
  Divider,
  // InputNumber,
  Link,
  PageHeader,
  Popover,
  Progress,
  Radio,
  Rate,
  Row,
  Slider,
  Steps,
  Switch,
  Table,
  TableColumn,
  Tag,
  Tooltip,
  Carousel,
  Cascader,
  Collapse,
  ColorPicker,
  TimePicker,
  DatePicker,
  // DateTimePicker,
  TimeSelect,
  TimePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Popconfirm,
  Timeline,
  Transfer,
  Tree,
  Upload,
  RadioGroup,
  RadioButton,
  CheckboxButton,
  CheckboxGroup,
  ButtonGroup
]

// js工具类
import middleware from './utils/middleware'
// 指令
import directives from './directives'
import element from './utils/element'
import i18n from './lang'
export const Middleware = middleware

const { Card, CardList } = CardGroup
const { Tabs, TabPane } = TabGroup
const { Select, Option, OptionGroup } = SelectGroup
const { BottomNav, BottomNavItem } = BottomNavGroup
const { FileList, FileItem } = FileListGroup
// 组件集合
const components = [AutoWrap, AgGridWrap]

export { AG_GRID_LOCALE_CN } from '../lib/lang/ag-grid.zh'

const replaceComponents = [
  AgGrid,
  AgGridTextTooltip,
  AgGridWrap,
  BtnPosition,
  CommonAgGrid,
  Dialog,
  Card,
  CardList,
  DialogTable,
  DialogTree,
  Drawer,
  Filter,
  FilterBtn,
  FilterForm,
  Form,
  FormCard,
  FormCardList,
  FormItem,
  InputDialog,
  InputNumber,
  Layout,
  Logo,
  Navbar,
  Pagination,
  Pop,
  RightMenu,
  SearchForm,
  SearchSelect,
  Sidebar,
  TabPane,
  Tabs,
  TreeTable,
  Select,
  ThemeEditor,
  Option,
  OptionGroup,
  NavRightMenu,
  TopNav,
  BottomNav,
  BottomNavItem,
  Soduku,
  FloatingButton,
  MultiSearch,
  SearchTagGroup,
  FRPrint,
  RFReport,
  Button,
  OnlyOffice,
  WordTemplateRender,
  FileList,
  FileItem
]
const COMP_PREFIX = 'Cube'
const install = function(Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(component.name, component)
  })
  replaceComponents.forEach((component) => {
    Vue.component(COMP_PREFIX + component.name, component)
    Vue.component('Cnd' + component.name, component)
  })
  elementComponents.forEach((component) => {
    const name = component.name.replace('El', COMP_PREFIX)
    Vue.component(name, component)
  })
  Vue.use(Loading.directive)
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$notify = Notification
  Vue.prototype.$message = Message
  Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key])
  })
  Vue.use(element, {
    i18n: (key, value) => i18n.t(key, value)
  })
  // eslint-disable-next-line no-extend-native
  Number.prototype.toFixed = function(n) {
    if (n > 20 || n < 0) {
      throw new RangeError('toFixed() digits argument must be between 0 and 20')
    }
    const number = this
    if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString()
    }
    if (typeof n === 'undefined' || n === 0) {
      return Math.round(number).toString()
    }
    let result = number.toString()
    const arr = result.split('.') // 整数的情况
    if (arr.length < 2) {
      result += '.'
      for (let i = 0; i < n; i += 1) {
        result += '0'
      }
      return result
    }
    const integer = arr[0]
    const decimal = arr[1]
    if (decimal.length === n) {
      return result
    }
    if (decimal.length < n) {
      for (let i = 0; i < n - decimal.length; i += 1) {
        result += '0'
      }
      return result
    }
    result = `${integer}.${decimal.substr(0, n)}`
    // 四舍五入，转换为整数再处理，避免浮点数精度的损失 正数+1 负数-1
    const last = decimal.substr(n, 1)
    if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n)
      result =
        (Math.round(parseFloat(result) * x) +
          (parseFloat(result) < 0 ? -1 : 1)) /
        x
      result = result.toFixed(n)
    }

    return result
  }
  Vue.prototype.$setEditState = function(state) {
    let visitedViews = []
    try {
      visitedViews = JSON.parse(sessionStorage.getItem('visitedViews')) || []
    } catch (error) {
      console.log(error)
    }
    const fullDialogList = Array.from(
      document.querySelectorAll('.dialog-container.mark-class')
    )
    // 子应用中路由地址不全,少了开头应用名
    const visite = visitedViews.find(
      (v) => v.fullPath.indexOf(this.$route.fullPath) !== -1
    )
    if (visite) {
      visite.dialogEdit = String(state)
      sessionStorage.setItem('visitedViews', JSON.stringify(visitedViews))
    }
    fullDialogList.forEach((dom) => {
      if (state) {
        dom.classList.remove('details-state-disable')
      } else {
        dom.classList.add('details-state-disable')
      }
    })
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  AgGrid,
  AgGridTextTooltip,
  AutoWrap,
  BtnPosition,
  Button,
  CommonAgGrid,
  Dialog,
  Card,
  CardList,
  DialogTable,
  DialogTree,
  Drawer,
  Filter,
  FilterBtn,
  FilterForm,
  Form,
  FormCard,
  FormCardList,
  FormItem,
  InputDialog,
  InputNumber,
  Layout,
  Logo,
  Navbar,
  Pagination,
  Pop,
  RightMenu,
  SearchForm,
  SearchSelect,
  Sidebar,
  TabPane,
  Tabs,
  TreeTable,
  AgGridWrap,
  Select,
  Option,
  OptionGroup,
  NavRightMenu,
  TopNav,
  BottomNav,
  BottomNavItem,
  Soduku,
  FloatingButton,
  MultiSearch,
  FRPrint,
  RFReport,
  SearchTagGroup,
  OnlyOffice,
  WordTemplateRender,
  Button,
  FileList,
  FileItem
}
